export enum PlatformType {
  ios,
  android,
  desktop,
  other,
}

/**
 * Detects the user's platform (iOS, Android, Desktop, or Other) safely without using deprecated APIs.
 */
export function detectPlatform(): PlatformType {
  const uaData = (navigator as any).userAgentData;
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // Prefer modern UA data if available
  if (uaData && uaData.platform) {
    const platform = uaData.platform.toLowerCase();

    if (platform.includes('ios')) return PlatformType.ios;
    if (platform.includes('android')) return PlatformType.android;
    if (platform.includes('win') || platform.includes('mac') || platform.includes('linux')) {
      return PlatformType.desktop;
    }
  }

  // Fallback detection using userAgent
  if (/android/i.test(userAgent)) return PlatformType.android;
  if (/iPad|iPhone|iPod/.test(userAgent)) return PlatformType.ios;
  if (/Windows|Macintosh|Linux/.test(userAgent)) return PlatformType.desktop;

  return PlatformType.other;
}
